module.exports = __webpack_public_path__ + "static/media/ralph.2f0e66c1.jpg";